import { UsedCommandType } from '~/constants/commands'
import { useCurrentConversation } from '~/contexts/CurrentConversationContext'
import { CommandType, commandTypeFromJSON, commandTypeToJSON } from '~/protos/agents'
import { ConversationMetadata } from '~/types/Conversations'

export function useConversationMetadata() {
  const { conversation } = useCurrentConversation()
  const metadata = conversation?.conversation_metadata || {
    mode: commandTypeToJSON(CommandType.NONE)
  }
  if (metadata.mode) {
    Object.assign(metadata, { command: commandTypeFromJSON(metadata.mode) as UsedCommandType })
  }
  return metadata as Partial<ConversationMetadata>
}
